import { render, staticRenderFns } from "./TabelaResultadoValidacaoNuc.vue?vue&type=template&id=319858da&"
import script from "./TabelaResultadoValidacaoNuc.vue?vue&type=script&lang=js&"
export * from "./TabelaResultadoValidacaoNuc.vue?vue&type=script&lang=js&"
import style0 from "./TabelaResultadoValidacaoNuc.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports